import { InjectionToken } from '@angular/core';

/**
 * A Lucide icon node — the tuple shape exported by every named icon in the
 * `lucide` package, e.g. `import { House } from 'lucide'`. Re-declared here so
 * consumers don't need to depend on lucide's (un-exported) `IconNode` type.
 *
 *   ["svg", {…attrs}, [ ["path", {d:"…"}], ["circle", {cx,cy,r}] ]]
 */
export type IconChild = readonly [tag: string, attrs: Record<string, string | number>];
export type IconNode = readonly [tag: string, attrs: Record<string, string | number>, children?: IconChild[]];

/** A name→icon map. Register icons for string-based `<nb-icon name="…">` lookup. */
export type IconSet = Record<string, IconNode>;

/**
 * Multi-provider token of {@link IconSet}s. Each `provideNbIcons({...})` call
 * contributes one set; `nb-icon` merges them. Lets each app/feature register
 * only the icons it uses (tree-shakeable) rather than the whole catalogue.
 */
export const NB_ICONS = new InjectionToken<IconSet[]>('NB_ICONS');
